export default __webpack_public_path__ + "static/media/img4.bce77022.jpg";